// PsyPractice — hukuki belgeler / Türkçe.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar — aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir —
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Şahıs İşletmesi";

const OWNER = 'PsyPractice (bundan böyle "Platform" veya "Veri Sorumlusu")';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Kullanım Koşulları & Sorumluluk Reddi",
    description:
      "Hizmetin niteliği ve sınırları, neyin yerine geçmediği, kullanıcı taahhütleri ve tüm sorumluluğun kullanıcıya ait olduğu kapsamlı feragat.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Taraflar ve Kabul",
        paras: [
          `Bu Kullanım Koşulları, ${OWNER} ile Platforma erişen veya onu kullanan gerçek/tüzel kişi (bundan böyle "Kullanıcı") arasında akdedilir. Kullanıcı, hesap oluşturarak, oturum açarak veya Platformu herhangi bir biçimde kullanarak bu koşulların tamamını okuduğunu, anladığını ve kayıtsız şartsız kabul, beyan ve taahhüt ettiğini onaylar. Koşulları kabul etmeyen kişi Platformu kullanmamalıdır.`,
        ],
      },
      {
        heading: "2. Hizmetin Niteliği ve Sınırları",
        bullets: [
          "PsyPractice, psikoloji öğrencilerinin ve klinisyen adaylarının görüşme pratiğini güvenli bir ortamda yürütmesini ve kaydetmesini sağlayan, yapay zekâ destekli bir hasta SİMÜLASYON yazılımıdır.",
          "PsyPractice bir eğitim veya öğretim hizmeti değil, kullanıcının kendi pratiğini yürütmesini ve kaydetmesini sağlayan bir yazılım aracıdır. Platform ders, müfredat, sınav veya belge sunmaz; hiçbir unvan, yeterlilik ya da yetki kazandırmaz.",
          "Simüle edilen “hasta” gerçek bir danışan değildir; ürettiği yanıtlar yapay zekâ tarafından sentezlenir, hatalı, eksik, tutarsız veya yanıltıcı olabilir ve hiçbir klinik gerçeklik ya da doğruluk iddiası taşımaz.",
        ],
      },
      {
        heading: "2.1. Platformun Yerine Geçmediği Şeyler",
        bullets: [
          "Gerçek terapi ya da danışmanlık DEĞİLDİR; gerçek bir danışanla yürütülen hiçbir görüşmenin yerine geçmez.",
          "Klinik süpervizyonun YERİNE GEÇMEZ. Süpervizör yapay zekânın ürettiği geri bildirim raporları otomatik üretilmiş metinlerdir; uzman görüşü, resmî değerlendirme ya da not değildir.",
          "Tanı, tarama veya değerlendirme aracı DEĞİLDİR; Platformun hiçbir çıktısı gerçek bir kişi hakkında tanısal veya klinik karar amacıyla kullanılamaz.",
          "Kriz ve acil durumlarda KULLANILAMAZ. İntihar düşüncesi, kendine ya da bir başkasına zarar verme riski veya benzeri acil hâllerde Platform kapatılmalı ve derhâl yerel acil servislere ya da yetkili bir sağlık kuruluşuna başvurulmalıdır.",
          "Mesleki yeterlilik, ruhsat, unvan ya da yetki kaynağı DEĞİLDİR; Platformdaki kullanım süresi veya çıktıları hiçbir kurum önünde yeterlilik kanıtı olarak ileri sürülemez.",
        ],
      },
      {
        heading: "3. Kullanıcının Beyan ve Taahhütleri",
        bullets: [
          "Kullanıcı, Platformu yalnızca yasal ve etik sınırlar içinde, kendi mesleki pratiğini geliştirmek amacıyla kullanacağını taahhüt eder.",
          "Kullanıcı, Platforma GERÇEK hasta/danışan verisi, kimlik bilgisi veya herhangi bir kişiye ait özel nitelikli sağlık verisi GİRMEYECEĞİNİ kabul eder; aksi davranışın tüm hukuki sonuçları münhasıran Kullanıcıya aittir.",
          "Kullanıcı, Platformdan edindiği hiçbir çıktıyı gerçek bir kişiye dönük tanı, tedavi, müdahale veya klinik karar amacıyla kullanmayacağını taahhüt eder.",
          "Kullanıcı, kendi mesleki yeterliliğini, yetki sınırlarını ve ilgili meslek/etik mevzuatına uyumunu sağlamaktan bizzat sorumludur.",
          "Hesap güvenliği, parola gizliliği ve hesabı altında gerçekleşen tüm işlemlerin sorumluluğu Kullanıcıya aittir.",
          "Hesap kişiseldir; Kullanıcı hesabını başkalarıyla paylaşmamayı ve Platformu otomatik araçlarla (bot, betik vb.) kullanmamayı taahhüt eder. Ücretli planlardaki kullanım, adil kullanım sınırına (hâlihazırda takvim ayı başına 60 seans) tabidir; ayrıntısı Mesafeli Satış Sözleşmesi'ndedir.",
        ],
      },
      {
        heading: "4. Sorumluluğun Tamamen Kullanıcıya Ait Olması (Feragat)",
        paras: [
          "Platform “OLDUĞU GİBİ” ve “MEVCUT HALİYLE” sunulur; açık veya zımni hiçbir garanti (kesintisizlik, hatasızlık, belirli bir amaca uygunluk, doğruluk, güncellik dâhil) verilmez.",
          "Kullanıcı; Platformu kullanması veya kullanamamasından, yapay zekâ çıktılarına güvenmesinden ya da bu çıktıları herhangi bir şekilde uygulamasından doğabilecek her türlü doğrudan, dolaylı, arızi, özel veya sonuç niteliğindeki zararın (maddi, manevi, mesleki itibar, veri kaybı, gelir kaybı, üçüncü kişilere verilen zararlar dâhil) tamamından MÜNHASIRAN ve ŞAHSEN sorumlu olduğunu kabul ve taahhüt eder.",
          "Kullanıcı, herhangi bir olumsuzluk hâlinde karşılaşabileceği her türlü zarara karşı Platforma, sahiplerine, çalışanlarına, geliştiricilerine, iş ortaklarına ve hizmet sağlayıcılarına yönelebilecek her türlü talep, dava ve tazminat hakkından — yürürlükteki mevzuatın izin verdiği en geniş ölçüde — şimdiden, geri dönülmez biçimde, gayrikabili rücu olarak FERAGAT ettiğini kabul, beyan ve taahhüt eder.",
          "Kullanıcı ayrıca, kendi kusur, ihmal veya bu koşullara aykırı kullanımı nedeniyle Platformun herhangi bir üçüncü kişi ya da kurum tarafından muhatap alınması hâlinde, Platformu her türlü talep, zarar, ceza ve masraftan (avukatlık ücretleri dâhil) tamamen ârî kılacağını (tazmin/garanti) taahhüt eder.",
        ],
      },
      {
        heading: "5. Sorumluluğun Sınırlandırılması",
        paras: [
          "Yürürlükteki hukukun emredici hükümleri saklı kalmak kaydıyla, Platformun toplam yasal sorumluluğu — her hâlükârda — Kullanıcının ilgili talebe konu olaydan önceki 12 ayda Platforma fiilen ödediği ücret tutarı ile sınırlıdır. Ücretsiz kullanım hâlinde bu tutar sıfırdır.",
        ],
      },
      {
        heading: "6. Fikrî Mülkiyet, Değişiklik ve Fesih",
        bullets: [
          "Platform, yazılımı, tasarımı, hasta vaka şablonları ve içerikleri üzerindeki tüm fikrî mülkiyet hakları Platforma aittir.",
          "Kullanıcının Platform üzerinde oluşturduğu içerik (yazdığı terapist mesajları, seans transkriptleri ve bunlardan türeyen materyaller dâhil) üzerindeki devredilebilir tüm mali fikrî mülkiyet hakları, içeriğin oluşturulduğu anda münhasıran, süresiz ve bedelsiz olarak Platforma devredilmiş sayılır; Platform bu içeriği hizmetin sunulması, geri bildirim üretimi ile sistemin geliştirilmesi ve eğitilmesi dâhil her amaçla dünya çapında, sınırsız biçimde kullanabilir, çoğaltabilir ve işleyebilir. Kullanıcının yürürlükteki veri koruma mevzuatından (GDPR / KVKK) doğan kişisel veri hakları bu devirden etkilenmez ve saklıdır.",
          "Platform, bu koşulları ve hizmet kapsamını dilediği zaman, önceden bildirmeksizin değiştirme, askıya alma veya sonlandırma hakkını saklı tutar.",
          "Koşullara aykırılık hâlinde Platform, hesabı önceden bildirimde bulunmaksızın askıya alabilir veya kapatabilir.",
        ],
      },
      {
        heading: "7. Uygulanacak Hukuk ve Yetki",
        paras: [
          "Bu koşullar Türkiye Cumhuriyeti hukukuna tabidir. Doğabilecek uyuşmazlıklarda Türkiye Cumhuriyeti mahkemeleri ve icra daireleri yetkilidir.",
          "Avrupa Birliği'nde yerleşik tüketiciler bakımından, bulundukları ülkenin emredici tüketici koruma hükümlerinden ve GDPR kapsamındaki veri koruma haklarından doğan korumalar saklıdır; bu hukuk seçimi söz konusu emredici hükümleri bertaraf etmez.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Gizlilik Politikası",
    description:
      "Temel standart olarak GDPR; işlenen veriler, hukuki sebepler, AB'de barındırma, uluslararası aktarım (AI sağlayıcı) ve Türkiye'deki kullanıcılar için KVKK md. 9 yurt dışı aktarım maddesi.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Bu Gizlilik Politikası, ${OWNER} tarafından işletilen Platform kapsamında kişisel verilerin nasıl işlendiğini açıklar. Politika, temel veri koruma standardı olarak Avrupa Birliği Genel Veri Koruma Tüzüğü'nü (GDPR / 2016/679) esas alır; Türkiye'de bulunan kullanıcılar için ek olarak 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) — özellikle yurt dışı aktarıma ilişkin md. 9 — uygulanır. KVKK Aydınlatma Metni ve Açık Rıza Metni bu politikanın ayrılmaz parçalarıdır.`,
        ],
      },
      {
        heading: "Veri sorumlusu ve barındırma yeri",
        bullets: [
          "Veri sorumlusu (data controller): PsyPractice. İlgili kişi/veri sahibi başvuruları için Platformda ilan edilen iletişim kanalı kullanılır (iletişim e-postası: info@psycora.com).",
          "Barındırma: Platform ve veritabanı, Avrupa Birliği içinde — Hollanda'daki bir veri merkezinde (Oracle Cloud) barındırılır. AB/AEA'da bulunan kullanıcılar bakımından veriler AB içinde işlenir ve saklanır.",
          "Barındırma sağlayıcısı yalnızca veri işleyen (processor) sıfatıyla, akdedilen Veri İşleme Sözleşmesi (DPA) çerçevesinde hareket eder.",
        ],
      },
      {
        heading: "İşlenen veriler",
        bullets: [
          "Hesap verileri: ad, e-posta, şifrelenmiş parola, abonelik/plan bilgisi.",
          "Kullanım verileri: oluşturulan seanslar, seans transkriptleri, üretilen hasta vakaları, süpervizör geri bildirim raporları.",
          "Teknik veriler: oturum kayıtları, IP, tarayıcı/locale tercihi, hız sınırı (rate-limit) ve güvenlik kayıtları.",
        ],
      },
      {
        heading: "İşleme amaçları ve hukuki sebep (GDPR md. 6)",
        bullets: [
          "Sözleşmenin ifası (md. 6/1-b): hesap oluşturma, seans yürütme, çok-seanslı hasta hafızası, süpervizör değerlendirmesi, abonelik ve kullanım limiti yönetimi.",
          "Meşru menfaat (md. 6/1-f): güvenlik, kötüye kullanımın önlenmesi, sistem iyileştirme ve hata ayıklama.",
          "Hukuki yükümlülük (md. 6/1-c): mevzuattan doğan saklama/raporlama yükümlülükleri.",
          "Açık rıza (md. 6/1-a): hizmet için zorunlu olmayan analitik/ürün iyileştirme işlemeleri ve — gerektiğinde — AB/AEA dışına aktarım.",
        ],
      },
      {
        heading: "Uluslararası aktarım",
        paras: [
          "Barındırma AB içinde (Hollanda) olduğundan, AB/AEA kullanıcılarının verileri kural olarak AB içinde işlenir ve burada üçüncü ülkeye aktarım söz konusu değildir. Ancak yapay zekâ yanıtlarının üretilmesi için seans içerikleri ve istemler yapay zekâ hizmet sağlayıcısına (Anthropic) iletilir; bu sağlayıcının işleme altyapısı AB/AEA dışında (ör. ABD) bulunabilir.",
          "AB/AEA dışına yapılan bu aktarım, GDPR md. 44 vd. uyarınca uygun güvencelere — özellikle Avrupa Komisyonu Standart Sözleşme Hükümleri'ne (SCC) — dayandırılır ve sağlayıcılarla veri işleme sözleşmesi (DPA) akdedilir. Platform kişisel verileri pazarlama amacıyla SATMAZ; veriler hizmetin işletilmesi için zorunlu olanlar dışında üçüncü kişilerle paylaşılmaz (yasal mercilerin mevzuata uygun talepleri saklıdır).",
        ],
      },
      {
        heading: "Türkiye'deki kullanıcılar için — KVKK md. 9 (yurt dışı aktarım)",
        paras: [
          "Türkiye'de bulunan kullanıcıların kişisel verileri, barındırmanın Hollanda'da (AB) olması nedeniyle Türkiye dışına aktarılır; ayrıca yapay zekâ işleme için Anthropic'e aktarılabilir. Bu aktarımlar KVKK md. 9 kapsamındadır ve uygun güvencelere (Kurul'un yayımladığı standart sözleşme / taahhütname) veya — gereken hâllerde — açık rızanıza dayanır. Aktarımın kapsamı, alıcıları ve amacı KVKK Aydınlatma Metni ile Açık Rıza Metni'nde ayrıntılı olarak açıklanır.",
        ],
      },
      {
        heading: "Veri sahibi hakları (GDPR md. 15–22)",
        bullets: [
          "Erişim, düzeltme, silme ('unutulma hakkı') ve işlemenin kısıtlanmasını isteme.",
          "Veri taşınabilirliği: sağladığınız verileri yapılandırılmış, yaygın kullanılan, makinece okunabilir biçimde alma.",
          "İtiraz: meşru menfaate dayalı işlemeye ve doğrudan pazarlamaya itiraz etme.",
          "Yalnızca otomatik işlemeye dayalı bireysel karar/profillemeye ilişkin haklar.",
          "Rızaya dayalı işlemelerde rızayı dilediğiniz an geri çekme (geri çekme, o ana kadarki işlemenin hukukiliğini etkilemez).",
          "Bir denetim makamına şikâyet hakkı: AB'de ilgili veri koruma otoritesi; Türkiye'de Kişisel Verileri Koruma Kurumu.",
        ],
      },
      {
        heading: "Saklama ve güvenlik",
        bullets: [
          "Veriler işleme amacının gerektirdiği süre ve ilgili mevzuatın öngördüğü süreler boyunca saklanır; süre dolduğunda silinir veya anonimleştirilir.",
          "Hassas alanlar (ör. parola, doğrulama ve sıfırlama kodları) şifreli/hash'li tutulur; erişim yetki bazlıdır.",
          "Hiçbir aktarım veya saklama yöntemi %100 güvenli olmadığından mutlak güvenlik garanti edilemez.",
        ],
      },
      {
        heading: "Gerçek hasta verisi yasağı",
        paras: [
          "Platform bir simülasyon yazılımıdır; gerçek danışanlara ait kişisel/sağlık verisi girilmesi yasaktır. Kullanıcının bu yasağa aykırı veri girmesinden doğacak tüm sorumluluk münhasıran Kullanıcıya aittir.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "KVKK Aydınlatma Metni",
    description:
      "6698 sayılı Kanun md. 10 kapsamında veri sorumlusu, işleme amaçları, hukuki sebep, aktarım ve ilgili kişi hakları.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Veri Sorumlusu",
        paras: [
          `6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) md. 10 uyarınca, kişisel verileriniz Veri Sorumlusu sıfatıyla ${OWNER} tarafından aşağıda açıklanan kapsamda işlenmektedir.`,
        ],
      },
      {
        heading: "İşlenen veriler ve amaçları",
        bullets: [
          "Kimlik/İletişim (ad, e-posta): hesap oluşturma, kimlik doğrulama, iletişim.",
          "Müşteri işlem (abonelik, plan, kullanım): hizmet sunumu, faturalandırma, limit uygulaması.",
          "İşlem güvenliği (oturum, IP, log): güvenlik, kötüye kullanımın önlenmesi, hukuki yükümlülük.",
          "Kullanıcı içerikleri (seans transkripti, üretilen vakalar): yazılım hizmetinin yürütülmesi ve geri bildirim üretimi.",
          "Kurumsal kohort üyeliği (kohort kimliği, üyelik süresi): kullanıcının bir kuruma bağlı kohorta katılması hâlinde, kohortun eğitmen ekibinin (kohortun eğitmeni ile eğitmenin kohorta eklediği eş eğitmen ve asistan) görüşü, puanların onaylanması ya da düzeltilmesi ve kohortun yürütülmesi.",
        ],
      },
      {
        heading: "Hukuki sebep (md. 5)",
        bullets: [
          "Sözleşmenin kurulması/ifası: hizmetin sunulması için zorunlu veriler.",
          "Veri sorumlusunun meşru menfaati: güvenlik, dolandırıcılık önleme, sistem iyileştirme.",
          "Hukuki yükümlülük: mevzuattan doğan saklama/raporlama.",
          "Açık rıza: yurt dışı aktarım (md. 9) ve hizmet için zorunlu olmayan ek işlemeler.",
        ],
      },
      {
        heading: "Yurt dışı aktarım (md. 9)",
        paras: [
          "Platform ve veritabanı Avrupa Birliği içinde — Hollanda'daki bir veri merkezinde (Oracle Cloud) barındırıldığından, Türkiye'de bulunan kullanıcıların kişisel verileri Türkiye dışına (AB'ye) aktarılır. Ayrıca, yapay zekâ yanıtlarının üretilmesi amacıyla seans içerikleri ve istemler, işleme altyapısı AB/AEA dışında (ör. ABD) bulunabilen yapay zekâ hizmet sağlayıcısına (Anthropic) aktarılabilir.",
          "Bu yurt dışı aktarımlar KVKK md. 9 kapsamındadır ve uygun güvencelere — Kurul'un yayımladığı standart sözleşme / taahhütname gibi — ya da gerektiğinde açık rızanıza dayanır. Barındırma ve hizmet sağlayıcılarıyla veri işleme sözleşmeleri (DPA) akdedilir.",
        ],
      },
      {
        heading: "Kurumsal kohort ve eğitmen görünürlüğü",
        paras: [
          "Bir üniversite, klinik ya da benzeri bir kurumun açtığı kohorta katılmanız hâlinde, kohort süresi boyunca seans içerikleriniz (transkriptler) ve süpervizör raporlarınız o kohortun eğitmen ekibi (kohortun eğitmeni ile eğitmenin kohorta eklediği eş eğitmen ve asistan) tarafından görülebilir. Eğitmen ekibi süpervizör raporlarınızdaki puanları onaylayabilir ya da düzeltebilir; seans içeriklerinizi ve raporlarınızı değiştiremez. Bu görünürlük yalnızca kohorta bağlı seanslarınızı kapsar ve kohort üyeliğiniz sona erdiğinde ortadan kalkar.",
          "Bu erişim, kohorta katılırken karşınıza çıkan AYRI bir açık rıza ekranıyla alınır; Platformun genel kullanım onayına dâhil değildir. Rıza vermezseniz kohorta katılamazsınız, ancak Platformu bireysel olarak kullanmaya aynı şekilde devam edersiniz. Rızanızı geri almanız hâlinde kohort üyeliğiniz sona erer, bireysel kullanımınız etkilenmez.",
        ],
      },
      {
        heading: "İlgili kişi hakları (md. 11)",
        bullets: [
          "Kişisel verinizin işlenip işlenmediğini öğrenme, işlenmişse bilgi talep etme.",
          "İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme.",
          "Yurt içi/yurt dışı aktarılan üçüncü kişileri bilme.",
          "Eksik/yanlış işlenmişse düzeltilmesini, şartlar oluştuğunda silinmesini/yok edilmesini isteme.",
          "İşlemenin münhasıran otomatik sistemlerle analizi sonucu aleyhe bir sonuç çıkmasına itiraz etme.",
          "Kanuna aykırı işleme nedeniyle zarara uğranması hâlinde zararın giderilmesini talep etme.",
        ],
      },
      {
        heading: "Başvuru",
        paras: [
          "Haklarınıza ilişkin taleplerinizi Veri Sorumlusunun ilan ettiği iletişim kanalı üzerinden iletebilirsiniz. Başvurular KVKK ve ilgili ikincil düzenlemelerde öngörülen sürelerde sonuçlandırılır.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Açık Rıza Metni",
    description:
      "Aydınlatma metninden ayrı; yurt dışı aktarım ve AI işlemeye yönelik özgür iradeyle verilen onay.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "KVKK Aydınlatma Metni'ni okuyup anladığımı; aşağıdaki işlemelere özgür irademle, bilgilendirilmiş şekilde ve açık biçimde rıza gösterdiğimi beyan ederim. (KVKK Kurulu'nun 2018/90 sayılı kararı uyarınca açık rıza, aydınlatma yükümlülüğünden ayrı olarak alınır.)",
        ],
      },
      {
        heading: "Rıza verilen işlemeler",
        bullets: [
          "Kişisel verilerimin, Platformun Avrupa Birliği'nde (Hollanda / Oracle Cloud) barındırılması nedeniyle Türkiye dışına aktarılması ve orada saklanıp işlenmesi (KVKK md. 9).",
          "Seans transkriptlerim ve istemlerimin, yapay zekâ yanıtı üretilmesi amacıyla işleme altyapısı AB/AEA dışında bulunabilen yapay zekâ hizmet sağlayıcısına (Anthropic) aktarılması ve orada işlenmesi (KVKK md. 9).",
          "Hizmetin sunulması için zorunlu olmayan; ürün iyileştirme ve analitik amaçlı işlemeler.",
          "Tarafıma hizmetle ilgili bilgilendirme yapılması.",
        ],
      },
      {
        heading: "Rızanın geri alınması",
        paras: [
          "Açık rızamı dilediğim zaman geri alabileceğimi; ancak yurt dışı AI aktarımı hizmetin teknik olarak işlemesi için zorunlu olduğundan, bu rızayı geri almamın ilgili özellikleri ya da hizmetin tamamını kullanamamam sonucunu doğurabileceğini anladığımı kabul ederim. Geri alma, geri alma tarihine kadar gerçekleştirilen işlemelerin hukukiliğini etkilemez.",
        ],
      },
    ],
  },
  {
    // Bu belge PLATFORM KULLANICISI için değil, kurumsal tanıtım e-postası alan
    // akademisyen/kurum yetkilisi için yazılmıştır. KVKK md. 10 + Aydınlatma
    // Tebliği md. 6: veri ilgili kişiden elde edilmediğinde aydınlatma EN GEÇ
    // ilk iletişim anında yapılır — yani tanıtım e-postasının kendisi bu metne
    // link vermek zorundadır (/legal/public#outreach). Onay ekranına GİRMEZ
    // (consent ekranı yalnızca kvkk + consent belgelerini gösterir).
    id: "outreach",
    title: "Tanıtım İletişimi Aydınlatma Metni",
    description:
      "Kurumsal tanıtım e-postası alan akademisyen ve kurum yetkilileri için: verinin kaynağı, işleme amacı, hukuki sebebi ve listeden çıkma yolu.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Bu metin, PsyPractice tarafından üniversitelerin psikoloji bölümlerine ve akademik kadrolarına yönelik gönderilen kurumsal tanıtım e-postalarının alıcılarını, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) md. 10 ve Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ uyarınca bilgilendirmek amacıyla hazırlanmıştır. Kişisel verileriniz doğrudan sizden elde edilmediğinden, aydınlatma en geç sizinle kurulan ilk iletişim anında yapılır; bu metne tanıtım e-postasının içindeki bağlantıdan ulaşmış olmanızın sebebi budur.",
        ],
      },
      {
        heading: "1. Veri Sorumlusu",
        bullets: [
          `Unvan: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adres: ${MERCHANT.address}`,
          `Vergi Dairesi / No: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-posta: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. İşlenen kişisel veriler ve kaynağı",
        paras: [
          "İşlenen veriler yalnızca mesleki/kurumsal iletişim verileriyle sınırlıdır: ad-soyad, akademik unvan, görev yapılan üniversite ve bölüm, kurumsal e-posta adresi ve varsa kurumsal telefon numarası.",
          "Bu veriler sizden değil, üniversitelerin resmî bölüm ve akademik kadro sayfalarında herkese açık biçimde yayımlanmış hâllerinden derlenmiştir. Özel nitelikli kişisel veri işlenmez; kişisel (kurumsal olmayan) e-posta adresleri tanıtım amacıyla kullanılmaz.",
        ],
      },
      {
        heading: "3. İşleme amacı",
        paras: [
          "Verileriniz, psikoloji eğitiminde kullanılmak üzere geliştirilen bir yazılım aracının kurumsal tanıtımının yapılması, bölümünüzle olası bir pilot uygulama veya iş birliği görüşmesine davet edilmeniz ve bu görüşmeye ilişkin yazışmaların yürütülmesi amaçlarıyla işlenir. Başka bir amaçla kullanılmaz, satılmaz ve pazarlama amacıyla üçüncü kişilere aktarılmaz.",
        ],
      },
      {
        heading: "4. Hukuki sebep",
        paras: [
          "İşleme, KVKK md. 5/2-(f) uyarınca, temel hak ve özgürlüklerinize zarar vermemek kaydıyla veri sorumlusunun meşru menfaatine dayanır: iletişim yalnızca kurumsal adrese, yalnızca muhatabın mesleki faaliyet alanıyla doğrudan ilgili bir konuda ve sınırlı sayıda kurulur.",
          "Verinin internette herkese açık olması tek başına bir hukuki sebep sayılmaz. Kişisel Verileri Koruma Kurulu, bir verinin alenî olmasının onu her amaç için kullanılabilir kılmadığını, alenileştirme iradesinin ve amacının ayrıca değerlendirilmesi gerektiğini belirtmiştir; bu nedenle md. 5/2-(d) hukuki sebebine dayanılmamaktadır.",
        ],
      },
      {
        heading: "5. Aktarım ve saklama",
        paras: [
          "İletişim, altyapısı yurt dışında bulunabilen e-posta hizmet sağlayıcısı üzerinden yürütülür; bu kapsamdaki yurt dışı aktarımlar KVKK md. 9 çerçevesinde uygun güvenceler ile gerçekleştirilir.",
          "Verileriniz, iletişimin amacı ortadan kalktığında veya talebiniz üzerine silinir. Silme talebinden sonra size bir daha ulaşılmaması için, yalnızca bu amaçla sınırlı bir 'iletişim kurulmayacaklar' kaydı tutulur; bu kayıt tanıtım için kullanılamaz.",
        ],
      },
      {
        heading: "6. Ticari elektronik ileti ve ret hakkı",
        paras: [
          "Tanıtım niteliğindeki iletiler 6563 sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun kapsamındadır. Hiçbir gerekçe göstermeksizin ileti almayı reddedebilirsiniz; ret talebiniz en geç üç iş günü içinde işleme alınır ve tarafınıza bir daha tanıtım iletisi gönderilmez. Ret için gönderilen e-postayı yanıtlamanız ya da " + MERCHANT.email + " adresine yazmanız yeterlidir.",
        ],
      },
      {
        heading: "7. Haklarınız",
        paras: [
          "KVKK md. 11 uyarınca; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme, işleme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme, yurt içinde/yurt dışında aktarıldığı üçüncü kişileri bilme, eksik veya yanlış işlenmiş olması hâlinde düzeltilmesini isteme, silinmesini veya yok edilmesini isteme, yapılan işlemlerin aktarıldığı üçüncü kişilere bildirilmesini isteme, münhasıran otomatik sistemlerle analiz edilmesi suretiyle aleyhinize bir sonuç ortaya çıkmasına itiraz etme ve zarara uğramanız hâlinde zararın giderilmesini talep etme haklarına sahipsiniz.",
          `Taleplerinizi ${MERCHANT.email} adresine iletebilirsiniz; başvurularınız en geç otuz gün içinde sonuçlandırılır. Ayrıca Kişisel Verileri Koruma Kurulu'na şikâyette bulunma hakkınız saklıdır.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Çerez (Cookie) Politikası",
    description: "Kullanılan çerez türleri, amaçları ve tercih yönetimi.",
    // Kendi tarihi var: yalnızca landing ziyaretçisini ilgilendiren değişiklik
    // LEGAL_VERSION'ı artırıp herkesi yeniden onaya sokmasın (2026-10-28).
    updated: "2026-10-28",
    sections: [
      {
        paras: [
          "Platform, oturumun sürdürülmesi ve tercihlerinizin hatırlanması için çerez ve benzeri yerel depolama (localStorage) teknolojilerini kullanır. Tanıtım sitesi (psypractice.psycora.com) bunlara ek olarak analiz çerezleri kullanır, ancak yalnızca siz kabul ederseniz.",
        ],
      },
      {
        heading: "Kullanılan teknolojiler",
        bullets: [
          "Zorunlu: oturum/kimlik doğrulama jetonu, güvenlik. Bunlar olmadan hizmet çalışmaz.",
          "İşlevsel: dil/locale tercihi (NEXT_LOCALE), arayüz tercihleri (ör. tema) ve tanıtım sitesindeki çerez tercihiniz (pp_cookie_consent, 12 ay saklanır).",
          "Performans/güvenlik: hız sınırı ve kötüye kullanım tespiti için teknik kayıtlar.",
          "Analiz (yalnızca tanıtım sitesinde, yalnızca onayınızla): Google Etiket Yöneticisi üzerinden yüklenen Google Analytics 4, ziyaretçilerin siteyi nasıl bulduğunu ve kullandığını ölçer (_ga ve _ga_* çerezleri, en fazla 2 yıl saklanır). app.psypractice.psycora.com adresindeki uygulama analiz veya reklam çerezi kullanmaz.",
          "Reklam: şu anda etkin bir reklam etiketi yoktur. Reklam ölçümü etiketleri (ör. Google Ads) eklenirse yalnızca aynı onayla çalışır ve burada listelenir.",
        ],
      },
      {
        heading: "Google ve yurt dışına aktarım",
        paras: [
          "Analiz verileri (takma adlı tanımlayıcılar, ziyaret edilen sayfalar, cihaz ve tarayıcı bilgileri, IP adresinden türetilen yaklaşık konum) Google Ireland Limited ve altyapısı Amerika Birleşik Devletleri'nde bulunabilen Google LLC tarafından işlenir. Google LLC, AB-ABD Veri Gizliliği Çerçevesi kapsamında sertifikalıdır. Türkiye'deki kullanıcılar için bu yurt dışına aktarım (KVKK md. 9), Google'ın veri işleme koşullarındaki uygun güvencelere ya da gerektiğinde çerez bandında verdiğiniz onaya dayanır.",
        ],
      },
      {
        heading: "Tercih yönetimi",
        paras: [
          "Tarayıcınızdan çerezleri silebilir veya engelleyebilirsiniz; ancak zorunlu çerezlerin engellenmesi oturum açma ve temel işlevlerin çalışmamasına yol açar. GDPR / ePrivacy ilkeleri ve KVKK Çerez Rehberi doğrultusunda, zorunlu olmayan çerezler yalnızca açık tercihiniz/onayınız doğrultusunda kullanılır.",
          "Tanıtım sitesinde tercihinizi istediğiniz zaman alt bilgideki \"Çerez ayarları\" bağlantısından değiştirebilir ya da geri alabilirsiniz. Reddederseniz analiz çerezi yazılmaz; Google etiketi yine de cihazınızı tanımlamayan, çerezsiz ve toplu sinyaller (Google Onay Modu) gönderebilir.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Hakkımızda",
    description:
      "PsyPractice'in amacı, sunduğu hizmet ve işletme (satıcı) iletişim bilgileri.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice, psikoloji öğrencileri ve yeni mezun klinisyen adayları için geliştirilmiş, yapay zekâ destekli bir hasta simülasyonu ve klinik beceri geliştirme platformudur. Kullanıcılar metin tabanlı terapi seansları yürütür; her seansın sonunda bir süpervizör yapay zekâ, görüşmeyi değerlendirerek gelişimsel bir geri bildirim raporu üretir. Hasta yapay zekâsı, seanslar arası hafızayla terapötik ilişkiyi seans seans taşır.",
        ],
      },
      {
        heading: "Misyonumuz",
        paras: [
          "Amacımız, geleceğin ruh sağlığı uzmanlarına; gerçek danışanlara zarar verme riski olmadan, güvenli ve tekrarlanabilir bir ortamda görüşme pratiği yapma imkânı sunmaktır. PsyPractice bir eğitim veya öğretim hizmeti değil, kullanıcının kendi pratiğini yürütmesini ve kaydetmesini sağlayan bir yazılım aracıdır. Gerçek terapi ya da danışmanlık değildir, klinik süpervizyonun yerine geçmez, tanı veya değerlendirme aracı değildir ve kriz ile acil durumlarda kullanılamaz.",
        ],
      },
      {
        heading: "Ne sunuyoruz",
        bullets: [
          "Klinik literatürden sentezlenmiş çeşitli hasta profilleriyle metin tabanlı terapi seansı simülasyonu.",
          "Seans sonrası otomatik süpervizör değerlendirme raporları.",
          "Seanslar arası hafıza taşıyan, terapötik ilişkiyi geliştiren 'yaşayan hasta' modeli.",
          "Öğrencinin kendi vakasını yapay zekâ ile üretebildiği özel hasta oluşturma.",
          "Mikrobeceri gelişimini izleyen ilerleme metrikleri.",
        ],
      },
      {
        heading: "Satıcı / İşletme Bilgileri",
        bullets: [
          `Unvan: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adres: ${MERCHANT.address}`,
          `Vergi Dairesi / No: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-posta: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Mesafeli Satış Sözleşmesi",
    description:
      "6502 sayılı Kanun ve Mesafeli Sözleşmeler Yönetmeliği kapsamında satıcı, alıcı, hizmet, bedel, ödeme, ifa ve cayma hakkı koşulları.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Taraflar",
        bullets: [
          `SATICI: ${MERCHANT.legalName} (${OWNER_TYPE}). Adres: ${MERCHANT.address}. Vergi Dairesi/No: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-posta: ${MERCHANT.email}.`,
          "ALICI: Platformda üyelik oluşturarak ücretli abonelik satın alan gerçek/tüzel kişi (bundan böyle \"Alıcı\").",
        ],
      },
      {
        heading: "2. Sözleşmenin Konusu",
        paras: [
          "İşbu Sözleşmenin konusu, Alıcının Platform üzerinden elektronik ortamda satın aldığı, aşağıda nitelikleri ve satış bedeli belirtilen dijital hizmet aboneliğinin satışı ve ifasına ilişkin olarak tarafların 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri uyarınca hak ve yükümlülüklerinin belirlenmesidir.",
        ],
      },
      {
        heading: "3. Hizmetin Niteliği ve Bedeli",
        bullets: [
          "Satışa konu hizmet, PsyPractice yazılımının ücretli abonelik planı kapsamında sunulan yapay zekâ destekli hasta simülasyonu özellikleridir (dijital hizmet / yazılım kullanım hakkı).",
          "PsyPractice bir eğitim veya öğretim hizmeti değil, kullanıcının kendi pratiğini yürütmesini ve kaydetmesini sağlayan bir yazılım aracıdır. Abonelik bedeli, bu yazılıma erişim hakkının karşılığıdır; ders, müfredat, sınav, danışmanlık ya da belge bedeli değildir.",
          "Plan içeriği, süresi (aylık, 4 aylık dönem ya da yıllık) ve güncel bedeli, satın alma anında Platformun fiyatlandırma/ödeme ekranında açıkça gösterilir; vergiler dâhil toplam tutar ödeme öncesinde Alıcıya beyan edilir.",
          "Fiyatlar Platformda ilan edilen para biriminde geçerlidir; abonelik, iptal edilmediği sürece seçilen dönem sonunda aynı bedelle otomatik yenilenir.",
          "“Sınırsız seans” olarak sunulan planlarda kullanım, adil kullanım sınırına (hâlihazırda takvim ayı başına 60 seans) tabidir. Sınıra ulaşıldığında yeni seans, izleyen takvim ayının ilk gününden itibaren yeniden başlatılabilir; bu durum bedelde indirim ya da iade doğurmaz. Sınır, hesap paylaşımını ve otomatik kullanımı önlemek için konmuştur ve Satıcı bu sınırı ücreti ödenmiş abonelik süresi içinde Alıcı aleyhine değiştirmez.",
        ],
      },
      {
        heading: "4. Ödeme",
        paras: [
          "Ödemeler, lisanslı ödeme kuruluşu iyzico altyapısı üzerinden kredi/banka kartı ile güvenli biçimde tahsil edilir. Kart bilgileri Satıcı tarafından saklanmaz; ödeme işlemi iyzico'nun güvenli sistemleri üzerinden gerçekleştirilir. Yinelenen (abonelik) ödemelerde bedel, her yenileme döneminde Alıcının onayladığı kart üzerinden otomatik tahsil edilir.",
        ],
      },
      {
        heading: "5. İfa ve Teslimat",
        paras: [
          "Hizmet dijital niteliktedir ve fiziksel teslimat içermez. Ödemenin onaylanmasının ardından abonelik özellikleri Alıcının hesabında derhâl (anında) erişime açılır. İfa, elektronik ortamda ve ilgili abonelik süresi boyunca kesintisiz erişim sağlanarak gerçekleşir.",
        ],
      },
      {
        heading: "6. Cayma Hakkı ve İstisnası",
        bullets: [
          "Mesafeli Sözleşmeler Yönetmeliği md. 15/1-(ğ) uyarınca, elektronik ortamda anında ifa edilen ve gayrimaddi (dijital) mallar/hizmetler bakımından, Alıcının onayı ile ifaya başlanmış olması hâlinde cayma hakkı kullanılamaz.",
          "Alıcı, satın alma sırasında hizmetin anında ifa edileceğini ve bu nedenle cayma hakkının bulunmadığını kabul eder. Aboneliğini dilediği zaman iptal ederek yenilenmesini durdurabilir; iptal, içinde bulunulan ödenmiş dönemin sonunda yürürlüğe girer.",
          "İadeye ilişkin ayrıntılı koşullar için bkz. \"Teslimat ve İade Şartları\".",
        ],
      },
      {
        heading: "7. Uyuşmazlık ve Yürürlük",
        paras: [
          "Alıcı, uyuşmazlık hâlinde Ticaret Bakanlığınca ilan edilen parasal sınırlar dâhilinde yerleşim yerindeki Tüketici Hakem Heyetine veya Tüketici Mahkemelerine başvurabilir. İşbu Sözleşme, Alıcının elektronik ortamda onayı ile kurulur ve yürürlüğe girer.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Teslimat ve İade Şartları",
    description:
      "Dijital hizmetin teslimi, abonelik iptali, cayma istisnası ve ücret iadesi koşulları.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Teslimat (Dijital Hizmet)",
        bullets: [
          "PsyPractice tamamen dijital bir hizmettir; fiziksel ürün gönderimi ve kargo teslimatı yoktur.",
          "Ödeme onaylandığı anda abonelik özellikleri Alıcının hesabında otomatik ve anında etkinleşir; ayrı bir teslimat süresi veya teslimat ücreti bulunmaz.",
          "Hizmete internet bağlantısı olan herhangi bir cihazın web tarayıcısı üzerinden erişilir.",
        ],
      },
      {
        heading: "Abonelik İptali",
        bullets: [
          "Alıcı, aboneliğini dilediği zaman hesap ayarlarından iptal edebilir. İptal, mevcut ödenmiş dönemin sonunda yürürlüğe girer ve sonraki otomatik yenilemeyi durdurur.",
          "İptal sonrası, ödenmiş dönemin kalan süresi boyunca hizmete erişim devam eder.",
        ],
      },
      {
        heading: "Cayma Hakkı ve İade",
        bullets: [
          "Hizmet, Alıcının onayıyla anında ifa edilen dijital bir hizmet olduğundan, Mesafeli Sözleşmeler Yönetmeliği md. 15/1-(ğ) uyarınca kural olarak cayma hakkı ve buna bağlı iade hakkı doğmaz.",
          "Hatalı/çift çekim, teknik nedenlerle hizmete hiç erişilememesi veya benzeri açık kusur hâllerinde Alıcı, ödeme tarihinden itibaren makul süre içinde satıcıya başvurarak iade talep edebilir.",
          `İade talepleri ${MERCHANT.email} adresine iletilir; haklı bulunan iadeler, ödemenin yapıldığı karta iyzico altyapısı üzerinden, kural olarak 14 gün içinde iade edilir. İade süresi bankanın işlem süresine bağlı olarak değişebilir.`,
        ],
      },
      {
        heading: "İletişim",
        paras: [
          `Teslimat, iptal ve iade konularındaki tüm talepleriniz için: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
